// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__237FH","addWidgetButton":"Header_addWidgetButton__PwSVF","dashboardTabs":"Header_dashboardTabs__3S4YY","active":"Header_active__3Tqq4"};